import React from 'react';
import classNames from 'classnames';

import css from './IconPerson.module.css';

/**
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element}
 */
const IconPerson = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2381 1.07608C11.3802 0.83929 11.6873 0.762507 11.9241 0.904581L11.6668 1.33333C11.9241 0.904581 11.9239 0.904445 11.9241 0.904581L11.925 0.905137L11.9261 0.905771L11.9285 0.907274L11.9349 0.911219C11.9398 0.914269 11.946 0.918162 11.9533 0.922907C11.968 0.932395 11.9874 0.945311 12.0109 0.961732C12.0577 0.994546 12.1211 1.04155 12.1953 1.10338C12.3433 1.22678 12.537 1.41111 12.7298 1.66181C13.1184 2.16696 13.5002 2.93823 13.5002 3.99999C13.5002 5.06176 13.1184 5.83303 12.7298 6.33818C12.537 6.58888 12.3433 6.77321 12.1953 6.89661C12.1211 6.95844 12.0577 7.00544 12.0109 7.03826C11.9874 7.05468 11.968 7.06759 11.9533 7.07708C11.9497 7.07945 11.9463 7.0816 11.9432 7.08355C11.9401 7.0855 11.9374 7.08724 11.9349 7.08877L11.9285 7.09271L11.9261 7.09422L11.925 7.09485C11.9248 7.09499 11.9241 7.09541 11.6668 6.66666L11.9241 7.09541C11.6873 7.23748 11.3802 7.1607 11.2381 6.92391C11.0966 6.68812 11.1721 6.38257 11.4066 6.23972L11.4103 6.23736C11.4152 6.23422 11.4244 6.22812 11.4374 6.21902C11.4634 6.2008 11.5043 6.17071 11.5551 6.12838C11.657 6.04344 11.7967 5.91111 11.9372 5.72847C12.2153 5.36696 12.5002 4.80489 12.5002 3.99999C12.5002 3.1951 12.2153 2.63303 11.9372 2.27152C11.7967 2.08888 11.657 1.95655 11.5551 1.8716C11.5043 1.82927 11.4634 1.79919 11.4374 1.78096C11.4244 1.77187 11.4152 1.76577 11.4103 1.76263L11.4066 1.76027C11.1721 1.61742 11.0966 1.31187 11.2381 1.07608Z"
        fill="#9DC633"
      />
      <path
        d="M5.66683 6.66666C7.13959 6.66666 8.3335 5.47275 8.3335 3.99999C8.3335 2.52723 7.13959 1.33333 5.66683 1.33333C4.19407 1.33333 3.00016 2.52723 3.00016 3.99999C3.00016 5.47275 4.19407 6.66666 5.66683 6.66666Z"
        fill="#9DC633"
      />
      <path
        d="M0.333496 11.6667C0.333496 13.3235 0.333496 14.6667 5.66683 14.6667C11.0002 14.6667 11.0002 13.3235 11.0002 11.6667C11.0002 10.0098 8.61235 8.66666 5.66683 8.66666C2.72131 8.66666 0.333496 10.0098 0.333496 11.6667Z"
        fill="#9DC633"
      />
      <path
        d="M10.5907 2.23791C10.354 2.09584 10.0468 2.17262 9.90475 2.40941L10.0702 3.09174L10.0754 3.09529C10.0832 3.10075 10.098 3.11157 10.1176 3.12785C10.157 3.16071 10.2134 3.21388 10.2705 3.28818C10.3819 3.43303 10.5002 3.66176 10.5002 3.99999C10.5002 4.33822 10.3819 4.56696 10.2705 4.71181C10.2134 4.78611 10.157 4.83927 10.1176 4.87213C10.098 4.88842 10.0832 4.89923 10.0754 4.9047L10.0702 4.90825C9.83817 5.05188 9.76389 5.3558 9.90475 5.59058C10.0468 5.82736 10.354 5.90415 10.5907 5.76207L10.3335 5.33333C10.5907 5.76207 10.5905 5.76221 10.5907 5.76207L10.5916 5.76154L10.5926 5.76096L10.5947 5.75967L10.5997 5.75661L10.6125 5.74847C10.6223 5.74214 10.6345 5.73397 10.6489 5.72393C10.6775 5.70388 10.7148 5.67615 10.7578 5.64035C10.8433 5.56905 10.9536 5.46388 11.0631 5.32152C11.2851 5.03303 11.5002 4.5951 11.5002 3.99999C11.5002 3.40489 11.2851 2.96696 11.0631 2.67847C10.9536 2.53611 10.8433 2.43094 10.7578 2.35963C10.7148 2.32384 10.6775 2.29611 10.6489 2.27606C10.6345 2.26601 10.6223 2.25785 10.6125 2.25152L10.5997 2.24338L10.5947 2.24031L10.5926 2.23903L10.5916 2.23845C10.5914 2.23832 10.5907 2.23791 10.3335 2.66666L10.5907 2.23791Z"
        fill="#9DC633"
      />
    </svg>
  );
};

export default IconPerson;
